import { GET_HOTEL_CONTENT_ERR, GET_HOTEL_CONTENT_REQ, GET_HOTEL_CONTENT_RES } from '../constants';
import { handleAsync } from './reducerUtils';

const initState = {
  hotelcontent: null,
  hotelcontent_loaded: false,
  hotelerrors0: [],
};

const reducer = (state = initState, action) => {
  const next = handleAsync(state, action, { req: GET_HOTEL_CONTENT_REQ, res: GET_HOTEL_CONTENT_RES, err: GET_HOTEL_CONTENT_ERR, dataKey: 'hotelcontent', errorKey: 'hotelerrors0' });
  if (next) return next;

  switch (action.type) {
    default:
      return state;
  }
};

export default reducer;
